module.exports = __webpack_public_path__ + "static/media/skyway_helps_3.b9935186.jpg";